module.exports = __webpack_public_path__ + "static/img/img4d.6ecd5eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/img4d.png
// module id = wG7N
// module chunks = 1